import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Heading,
} from '@americanexpress/dls-react';

const CompletionPage = ({ onDone }) => (
  <div className="card pad-3-lr-md-up pad-1-lr-sm-down pad-responsive-extra width-full">
    <div className="text-align-center">
      <Heading
        level={1}
        variant="sans-large-bold"
        className="pad-3-b border-dark-b"
      >
        <FormattedMessage id="mainHeading" />
      </Heading>

      <div className="pad-4-t pad-2-b">
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="28" cy="28" r="28" fill="#006B2E" />
          <path d="M40 20L24 36L16 28" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      <Heading
        level={2}
        variant="sans-medium-bold"
        className="pad-2-b"
        style={{ color: '#006B2E' }}
      >
        <FormattedMessage id="documentSubmittedTitle" defaultMessage="Document Submitted" />
      </Heading>

      <p className="body-1 pad-2-b text-align-center" style={{ maxWidth: '480px', margin: '0 auto' }}>
        <FormattedMessage id="afterSubmissionBody" />
      </p>

      <div className="border-t pad-3-t" style={{ maxWidth: '480px', margin: '0 auto' }}>
        <Button
          id="doneButton"
          data-testid="DoneButton"
          variant="primary"
          onClick={onDone}
          style={{ minWidth: '200px', padding: '14px 48px', fontSize: '18px' }}
        >
          <FormattedMessage id="doneButtonLabel" defaultMessage="Done" />
        </Button>
      </div>
    </div>
  </div>
);

CompletionPage.propTypes = {
  onDone: PropTypes.func.isRequired,
};

export default CompletionPage;
